import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import Store from "@/pages/Store";
import Admin from "@/pages/Admin";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const BOOK_IDS = new Set([
  "hero-booking-button",
  "nav-book-button",
  "home-cta-book-button",
  "about-book-button",
  "booking-form-submit-button",
]);

function useGaTracking() {
  useEffect(() => {
    const handler = (e) => {
      if (typeof window.gtag !== "function") return;
      const el = e.target.closest("[data-testid]");
      if (!el) return;
      const id = el.getAttribute("data-testid");
      const lead = (label) =>
        window.gtag("event", "generate_lead", { event_category: "Engagement", event_label: label });
      if (id === "whatsapp-chat-button") return lead("WhatsApp Click");
      if (BOOK_IDS.has(id) || id.startsWith("service-book-")) return lead("Book a Slot Click");
      if (
        (id.includes("phone") && (id.includes("button") || id.includes("link") || id.includes("display"))) ||
        id.startsWith("services-call") || id.startsWith("home-cta-call")
      )
        return lead("Phone Call Click");
      if (id.includes("store"))
        return window.gtag("event", "select_content", {
          event_category: "Navigation",
          event_label: "Online Store click",
        });
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useGaTracking();

  return (
    <div className="App">
      <div className="noise-overlay" />
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/store" element={<Store />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <WhatsAppFloat />
      <Toaster theme="dark" richColors position="bottom-right" />
    </div>
  );
}

export default App;
